import {FullPageLoader} from '@common/ui/progress/full-page-loader';
import { UwCustomPage } from './loan-program/uw-custom-page';
import { useMdDataLoanProgram } from './loan-program/requests/use-md-data-loan-program';


export function ViewMdDataLoanProgramPage() {
  const query = useMdDataLoanProgram();

  if (query.status !== 'success') {
    return <FullPageLoader />;
  }

  return <PageContent md_data={query.data.md_data}/>;
}

interface PageContentProps {
   md_data: string;
}
function PageContent({ md_data}: PageContentProps) {
  return (
    <>
      <UwCustomPage message={md_data}/>
    </>
  );
}
